export { default } from './AirTempGraph';
